import classNames from 'classnames'
import { BasicCard } from '@winnin/winnin_ui.components.basic-card'

import type { ICardProps } from './card.types'

import './card.styles.scss'

export const Card = ({ children, className, dataTestId }: ICardProps) => {
  const containerClass = classNames('card-component-container', className)

  return (
    <BasicCard className={containerClass} dataTestId={dataTestId}>
      {children}
    </BasicCard>
  )
}

Card.displayName = 'Card'
